import TemplateTablev2 from "./TemplateTablev2";

export default TemplateTablev2;
